// (c) 2023 ABBYY Development, Inc.

import { Agent } from 'types/agent';
import axios, { AxiosError } from 'libs/axios';
import { AGENTS_QUERY_KEY } from './query-keys';
import { useQuery } from 'react-query';

export const useAgents = () => {
    return useQuery<Agent[], AxiosError>(
        [AGENTS_QUERY_KEY],
        async () => {
            const { data } = await axios.get('/api/ui/agents');

            return data;
        },
        {
            keepPreviousData: true
        }
    );
};
